// extracted by mini-css-extract-plugin
export default {"login":"Login_login__pLyn-","login__center":"Login_login__center__ZVoPT","title":"Login_title__ZpPrq"};